export default (props = {}) => <svg width="75" height="18" viewBox="0 0 75 18" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<path d="M74.1006 0H1.52588e-05V15.9996H72.1006C73.2052 15.9996 74.1006 15.1041 74.1006 13.9996V0Z" fill="#7F5FFF"/>
<path d="M-9.27448e-05 15.9996L2.60156 17.9996V15.9996H-9.27448e-05Z" fill="#5A3EC8"/>
</svg>
